// =========================================================================================================================
// Arabic: ربي يسر ولا تعسر ,و تمم بالخير
// English: O my Lord, make this task easy for me, and do not make it difficult for me and let my affairs end with goodness.
// Code Author: Muhammad Muashir uddin
// =========================================================================================================================

import { add } from "@tweenjs/tween.js";
import { getAsset } from "../getAsset";

export class ListMini extends EventTarget {
  constructor() {
    super();
    this.selected = null;
    this.scene = null;
    this.assembly = null;
    this.hidden = null;
    this.totalItems = 0;
    this.filteredList = [];
    this.items = [];
    this.onSearchInput = this.onSearchInput.bind(this);
    this.listMini = document.createElement("div");
    this.listMini.classList.add("listMini");
    let div = document.createElement("div");
    div.classList.add("searchBox");
    this.listMini.appendChild(div);
    let searchIcon = document.createElement("img");
    searchIcon.classList.add("searchIcon");
    searchIcon.src = getAsset("search.svg", "images");
    div.appendChild(searchIcon);

    let input = document.createElement("input");
    input.classList.add("search");
    input.placeholder = "Search...";
    input.autocomplete = "off";
    input.addEventListener("input", this.onSearchInput);
    div.appendChild(input);

    let header = document.createElement("div");
    header.classList.add("header");
    this.listMini.appendChild(header);
    this.total = document.createElement("div");
    this.total.classList.add("total");
    this.total.innerText = "Total Meshes: 0 / 0";
    header.appendChild(this.total);
    let headerIconBox = document.createElement("div");
    headerIconBox.classList.add("headerIconBox");
    headerIconBox.style.gap = "1.75vh";
    // headerIconBox.style.width = "31%";
    header.appendChild(headerIconBox);
    this.view = document.createElement("img");
    this.view.setAttribute("state", true);
    this.view.id = "view";
    this.view.src = getAsset("eyeOpen.svg", "images");
    this.view.classList.add("icon");
    headerIconBox.appendChild(this.view);
    this.lock = document.createElement("img");
    this.lock.setAttribute("state", false);
    this.lock.id = "lock";
    this.lock.src = getAsset("unlock.svg", "images");
    this.lock.classList.add("icon");
    headerIconBox.appendChild(this.lock);

    this.list = document.createElement("div");
    this.list.classList.add("list");
    this.listMini.appendChild(this.list);
  }
  onSearchInput(e) {
    this.filteredList = this.items.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase()));
    this.total.innerText = "Total Meshes:  " + this.filteredList.length + " / " + this.totalItems;
    this.reloadList();
  }
  setItems(lst, assembly1, hidden1, scene1) {
    this.scene = scene1;
    this.assembly = assembly1;
    this.hidden = hidden1;
    this.items = lst;
    this.filteredList = lst;
    this.totalItems = lst.length;
    this.reloadList();
    this.total.innerText = "Total Meshes:  " + this.filteredList.length + " / " + this.totalItems;
  }
  toggleViewAll() {
    let s = this.view.getAttribute("state") == "true" ? true : false;
    s = !s;
    this.view.setAttribute("state", s);
    this.view.src = s ? getAsset("eyeOpen.svg", "images") : getAsset("eyeClose.svg", "images");
    for (let i = 0; i < this.filteredList.length; i++) {
      this.filteredList[i].visible = s;
      this.filteredList[i].userData.visible = s;
      if (s) {
        this.assembly.add(this.filteredList[i]);
      } else {
        this.hidden.add(this.filteredList[i]);
      }
    }
    let listItems = this.list.children;
    for (let i = 0; i < listItems.length; i++) {
      let item = listItems[i];
      let img = item.children[3].children[0];
      img.src = s ? getAsset("eyeOpen.svg", "images") : getAsset("eyeClose.svg", "images");
    }
  }
  toggleLockAll() {
    let s = this.lock.getAttribute("state") == "true" ? true : false;
    s = !s;
    this.lock.setAttribute("state", s);
    this.lock.src = s ? getAsset("lock.svg", "images") : getAsset("unlock.svg", "images");

    for (let i = 0; i < this.list.children.length; i++) {
      let item = this.list.children[i];
      let lock = item.children[3].children[1];
      lock.src = getAsset(this.lock.src, "images");

      let meshName = item.children[2].innerText;
      let mesh = this.scene.getObjectByName(meshName);
      mesh.userData.lock = s;
    }
  }
  reloadList() {
    this.list.innerHTML = "";
    let allvisible = false;
    let alllock = true;
    for (let i = 0; i < this.filteredList.length; i++) {
      let item = document.createElement("div");
      item.classList.add("item");
      if (i < this.filteredList.length - 1) {
        item.style.borderBottom = "1px solid #CCCCCC";
      }
      this.list.appendChild(item);
      item.setAttribute("itemType", "listMiniItem");
      let icon = document.createElement("img");
      icon.src = getAsset("iconCube.svg", "images");
      icon.classList.add("icon");
      icon.style.pointerEvents = "none";
      item.appendChild(icon);
      // let inputName = addInput(item, "inputName" + i, "", "inputName");
      let inputName = document.createElement("input");
      inputName.type = "text";
      inputName.id = "inputName" + i;
      inputName.classList.add("inputName");
      // inputName.style.pointerEvents = "all";
      // inputName.style.userSelect = "all";
      item.appendChild(inputName);
      // let label = addDiv(item, "label", "itemLabel");
      let label = document.createElement("div");
      label.innerHTML = this.filteredList[i].name;
      label.classList.add("itemLabel");
      item.appendChild(label);
      let mesh = this.scene.getObjectByName(this.filteredList[i].name);
      if (mesh.userData.visible) {
        allvisible = true;
      }
      if (!mesh.userData.lock) {
        alllock = false;
      }
      let headerIconBox = document.createElement("div");
      headerIconBox.classList.add("headerIconBox");
      item.appendChild(headerIconBox);

      let view = document.createElement("img");
      view.id = "miniView";
      view.src = this.filteredList[i].userData.visible ? getAsset("eyeOpen.svg", "images") : getAsset("eyeClose.svg", "images");
      view.classList.add("icon");
      headerIconBox.appendChild(view);

      let lock = document.createElement("img");
      lock.id = "miniLock";
      lock.src = this.filteredList[i].userData.lock ? getAsset("lock.svg", "images") : getAsset("unlock.svg", "images");
      lock.classList.add("icon");
      headerIconBox.appendChild(lock);

      let del = document.createElement("img");
      del.id = "miniDel";
      del.src = getAsset("delete.svg", "images");
      del.classList.add("icon");
      headerIconBox.appendChild(del);
    }
    let eye = allvisible ? getAsset("eyeOpen.svg", "images") : getAsset("eyeClose.svg", "images");
    this.view.src = eye;
    let lock = alllock ? getAsset("lock.svg", "images") : getAsset("unlock.svg", "images");
    this.lock.src = lock;
  }
  applyView(elem) {
    let filename = elem.src.split("/").pop();
    let s = filename == "eyeOpen.svg" ? true : false;
    s = !s;
    elem.src = s ? getAsset("eyeOpen.svg", "images") : getAsset("eyeClose.svg", "images");
    let meshName = elem.parentNode.parentNode.children[2].innerText;
    let mesh = this.scene.getObjectByName(meshName);
    mesh.userData.visible = s;
    if (s) {
      this.assembly.add(mesh);
    } else {
      this.hidden.add(mesh);
    }
  }
  applyLock(elem) {
    let filename = elem.src.split("/").pop();
    let s = filename == "lock.svg" ? true : false;
    s = !s;
    elem.src = s ? getAsset("lock.svg", "images") : getAsset("unlock.svg", "images");
    let meshName = elem.parentNode.parentNode.children[2].innerText;
    let mesh = this.scene.getObjectByName(meshName);
    mesh.userData.lock = s;
  }
  selectMesh(elem) {
    if (this.selected) {
      this.selected.style.background = "#FFFFFF";
      this.selected.style.color = "#333333";
    }
    let lbl = elem.children[2];
    lbl.style.background = "#388e3c";
    lbl.style.color = "#FFFFFF";
    this.selected = lbl;
  }
  selectListItem(name) {
    let listItems = this.list.children;
    if (this.selected) {
      this.selected.style.background = "#FFFFFF";
      this.selected.style.color = "#333333";
    }
    if (name != "") {
      for (let i = 0; i < listItems.length; i++) {
        let lbl = listItems[i].children[2];
        if (lbl.innerText == name) {
          lbl.style.background = "#388e3c";
          lbl.style.color = "#FFFFFF";
          this.selected = lbl;
          this.smoothScrollToParent(this.list, listItems[i], 300);
          break;
        }
      }
    }
  }
  smoothScrollToParent(list, item, duration = 300) {
    let start = list.scrollTop;
    let itemRect = item.getBoundingClientRect();
    let listRect = list.getBoundingClientRect();
    let itemTop = itemRect.top - listRect.top + list.scrollTop;
    let target = itemTop;
    let distance = target - start;
    let startTime = null;

    function animation(currentTime) {
      if (!startTime) startTime = currentTime;
      let elapsed = currentTime - startTime;
      let progress = Math.min(elapsed / duration, 1);
      let ease = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
      list.scrollTop = start + distance * ease;
      if (elapsed < duration) {
        requestAnimationFrame(animation);
      }
    }
    requestAnimationFrame(animation);
  }
  appendTo(parent) {
    if (parent instanceof HTMLElement) {
      parent.appendChild(this.listMini);
    } else {
      console.error("Invalid parent element. It must be an HTMLElement.");
    }
  }
  hideInput(elem) {
    let item = elem.parentNode;
    elem.style.display = "none";
    item.children[2].style.display = "flex";
  }
  updateLabel(elem, str) {
    let item = elem.parentNode;
    let lbl = item.children[2].innerText;
    elem.style.display = "none";
    elem.value = str;
    item.children[2].innerText = str;
    item.children[2].style.display = "flex";
    // let mesh = this.scene.getObjectByName(lbl);
    // alert(mesh.name);
    // mesh.name = str;
    // alert(mesh.name)
    // this.items.sort((a, b) => a.name.localeCompare(b.name));
    // this.filteredList = [];
    // this.filteredList = [...this.items];
    // this.filteredList = this.items.filter((item) => item.name.toLowerCase().includes(str.toLowerCase()));
    // this.filteredList = this.items.filter((item) => item.name.toLowerCase().includes(str));
    // this.reloadList();
  }
}
